export default __webpack_public_path__ + "static/media/formulario.7f8eec22.png";